<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
	<!-- This is the tree node template for leaf nodes -->
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
		<!-- use a disabled button to provide padding for tree leaf -->
		<button disabled mat-icon-button></button>
		<ng-container
			*ngTemplateOutlet="
				templateRef;
				context: { $implicit: node, treeControl: treeControl, index: node.index }
			"
		/>
	</mat-tree-node>
	<!-- This is the tree node template for expandable nodes -->
	<mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
		<button
			mat-icon-button
			matTreeNodeToggle
			[attr.aria-label]="'toggle ' + node.name"
			(click)="updateVisibleNode()"
		>
			<mat-icon class="mat-icon-rtl-mirror">
				{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
			</mat-icon>
		</button>
		<ng-container
			*ngTemplateOutlet="
				templateRef;
				context: { $implicit: node, treeControl: treeControl, index: node.index }
			"
		/>
	</mat-tree-node>
</mat-tree>
